import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "../pages/home/page";
import NewsList from "@/pages/news/page";
import NewsDetail from "@/pages/news/detail/page";
import RecommendList from "@/pages/recommend/page";
import RecommendDetail from "@/pages/recommend/detail/page";
import Special from "@/pages/special/page";
import Search from "@/pages/search/page";
import About from "@/pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "news", element: <NewsList /> },
      { path: "news/:id", element: <NewsDetail /> },
      { path: "recommend", element: <RecommendList /> },
      { path: "recommend/:id", element: <RecommendDetail /> },
      { path: "special", element: <Special /> },
      { path: "search", element: <Search /> },
      { path: "about", element: <About /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;